import React, { useState } from "react";
import { useAuditoria } from "../contexts/AuditoriaContext";
import AuditoriaGrid from "../components/AuditoriaGrid";
import MotivoModal from "../modals/MotivoModal";
import { useAuditoriaUtils } from "../hooks/useAuditoriaUtils";

export default function AuditoriaView() {
  const { updateAuditoria, auditingRows, filtroPrestaciones } = useAuditoria();
  const [motivoModalOpen, setMotivoModalOpen] = useState(false);
  const [motivoRow, setMotivoRow] = useState(null);

  const { handleMotivoSubmit, aprobarRechazar } = useAuditoriaUtils();

  return (
    <>
      <AuditoriaGrid
        auditingRows={auditingRows}
        updateAuditoria={updateAuditoria}
        setMotivoRow={setMotivoRow}
        setMotivoModalOpen={setMotivoModalOpen}
        aprobarRechazar={aprobarRechazar}
        filtroPrestaciones={filtroPrestaciones}
      />
      <MotivoModal
        open={motivoModalOpen}
        onClose={() => setMotivoModalOpen(false)}
        onSubmit={(motivo) =>
          handleMotivoSubmit({
            motivo,
            motivoRow,
            auditingRows,
            updateAuditoria,
          }).finally(() => setMotivoModalOpen(false))
        }
      />
    </>
  );
}
